import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import Pharmacytabs from "../Components/Pharmacytabs";
import { imgpharmacy } from "../Constant/Index";

const PrescriptionOrdersall = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content  radius-20 p-4">
								<div className="right-side-element">
									<div className="row pe-3">
										<div className="col-lg-7">
											<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
												<div class="edit-btn back">
													<Link to="/">
														<div class="nav-anchor">
															<i class="fa-solid fa-arrow-left"></i>
														</div>
													</Link>
												</div>
												<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
													Prescription Orders
												</h5>
											</div>
											<Pharmacytabs />
										</div>
										<div className="col-lg-5">
											<div className="row">
												<div className="col-lg-6">
													<div className="main-order-wrapper">
														<h4>120</h4>
														<h5>Total Orders</h5>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="main-order-wrapper">
														<h4>03</h4>
														<h5>Completed Orders</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row mt-3 pe-3">
										<div className="col-lg-6">
											<div className="doctor-detail-des border-colorful  radius-20 p-4">
												<div className="d-flex align-items-center justify-content-between">
													<div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={imgpharmacy}
															className="img-fluid"
															alt=""
														/>
														<div>
															<h4 className="main-heading-font level-7 dark-color mb-0">
																John Doe
															</h4>
															<h5 className="mb-0 level-8 extra-color-9">
																Prescription
															</h5>
														</div>
													</div>
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-pending dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>Pending</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-pending"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to="/prescription-orders-all"
																>
																	All
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to="/prescription-orders-Panding"
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to="/prescription-orders-inprogress"
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to="/prescription-orders-complete"
																>
																	Complete
																</Link>
															</li>
														</ul>
													</div>
												</div>
												<div className="flex-x2 mt-3">
													<div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Laudantium
															</h4>
															<h4 className="extra-color-16 level-7">- X2</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Rem Aperiam
															</h4>
															<h4 className="extra-color-16 level-7">- X3</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Veritatis Et Quasi
															</h4>
															<h4 className="extra-color-16 level-7">- X4</h4>
														</div>
													</div>
													<div>
														<div className="mt-2">
															<h4 className="extra-color-16 level-7 mb-0">
																Prescribed By:
															</h4>
															<h4 className="extra-color-16 level-6">
																Dr. Dave Patil
															</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-lg-6">
											<div className="doctor-detail-des golder-border  radius-20 p-4">
												<div className="d-flex align-items-center justify-content-between">
													<div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={imgpharmacy}
															className="img-fluid"
															alt=""
														/>
														<div>
															<h4 className="main-heading-font level-7 dark-color mb-0">
																John Doe
															</h4>
															<h5 className="mb-0 level-8 extra-color-9">
																Prescription
															</h5>
														</div>
													</div>
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-progress dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>In Progress</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-progress"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item black-progress"
																	to=""
																>
																	All
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-progress"
																	to=""
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-progress"
																	to=""
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-progress"
																	to=""
																>
																	Complete
																</Link>
															</li>
														</ul>
													</div>
												</div>
												<div className="flex-x2 mt-3">
													<div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Laudantium
															</h4>
															<h4 className="extra-color-16 level-7">- X2</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Rem Aperiam
															</h4>
															<h4 className="extra-color-16 level-7">- X3</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Veritatis Et Quasi
															</h4>
															<h4 className="extra-color-16 level-7">- X4</h4>
														</div>
													</div>
													<div>
														<div className="mt-2">
															<h4 className="extra-color-16 level-7 mb-0">
																Prescribed By:
															</h4>
															<h4 className="extra-color-16 level-6">
																Dr. Dave Patil
															</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-lg-6 mt-3">
											<div className="doctor-detail-des golder-border  radius-20 p-4">
												<div className="d-flex align-items-center justify-content-between">
													<div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={imgpharmacy}
															className="img-fluid"
															alt=""
														/>
														<div>
															<h4 className="main-heading-font level-7 dark-color mb-0">
																John Doe
															</h4>
															<h5 className="mb-0 level-8 extra-color-9">
																Prescription
															</h5>
														</div>
													</div>
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-complete dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>Completed</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-complete"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	All
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-complete"
																	to=""
																>
																	Complete
																</Link>
															</li>
														</ul>
													</div>
												</div>
												<div className="flex-x2 mt-3">
													<div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Laudantium
															</h4>
															<h4 className="extra-color-16 level-7">- X2</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Rem Aperiam
															</h4>
															<h4 className="extra-color-16 level-7">- X3</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Veritatis Et Quasi
															</h4>
															<h4 className="extra-color-16 level-7">- X4</h4>
														</div>
													</div>
													<div>
														<div className="mt-2">
															<h4 className="extra-color-16 level-7 mb-0">
																Prescribed By:
															</h4>
															<h4 className="extra-color-16 level-6">
																Dr. Dave Patil
															</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-lg-6 mt-3">
											<div className="doctor-detail-des border-colorful  radius-20 p-4">
												<div className="d-flex align-items-center justify-content-between">
													<div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={imgpharmacy}
															className="img-fluid"
															alt=""
														/>
														<div>
															<h4 className="main-heading-font level-7 dark-color mb-0">
																John Doe
															</h4>
															<h5 className="mb-0 level-8 extra-color-9">
																Prescription
															</h5>
														</div>
													</div>
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-pending dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>Pending</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-pending"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to=""
																>
																	All
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to=""
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to=""
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item black-pending"
																	to=""
																>
																	Complete
																</Link>
															</li>
														</ul>
													</div>
												</div>
												<div className="flex-x2 mt-3">
													<div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Laudantium
															</h4>
															<h4 className="extra-color-16 level-7">- X2</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Rem Aperiam
															</h4>
															<h4 className="extra-color-16 level-7">- X3</h4>
														</div>
														<div className="d-flex align-items-center gap-3 mt-1">
															<h4 className="extra-color-16 level-7">
																Veritatis Et Quasi
															</h4>
															<h4 className="extra-color-16 level-7">- X4</h4>
														</div>
													</div>
													<div>
														<div className="mt-2">
															<h4 className="extra-color-16 level-7 mb-0">
																Prescribed By:
															</h4>
															<h4 className="extra-color-16 level-6">
																Dr. Dave Patil
															</h4>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PrescriptionOrdersall;
